import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
//UI
import HomeLayout from '../../../layouts/HomeLayout';
import BtnTable from '../../../components/buttons/BtnTable';
import MainLoader from '../../../components/Loaders/MainLoader';
import IconStatus from '../../../components/icons/IconStatus';
import Error from '../../../components/errors/Error';
import UploadFileModal from '../../../components/modals/UploadFileModal';
//SLICE
import { deleteStudentThunk, getStudentsThunk, initialStateStudents } from '../../../store/slices/catalogs/students.slice';
import { uploadStudentExcelData } from '../../../store/slices/catalogs/uploadStudentData.slice';
import { resetState } from '../../../store/slices/catalogs/uploadStudentData.slice';
import HeaderComplete from '../../../components/headers/catalogs/HeaderComplete';
import { Link } from 'react-router-dom';
import BtnAdd from '../../../components/buttons/BtnAdd';

const StudentList = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { items, message, error } = useSelector(state => state.students);
    const { success, process, error_message } = useSelector(state => state.data_students_excel);
    const [searchTerm, setSearchTerm] = useState('');
    const isLoading = useSelector(state => state.isLoadingSlice);
    const user = JSON.parse(localStorage.getItem("userInfo"));

    useEffect(() => {
        dispatch(getStudentsThunk());
        return () => {
            dispatch(initialStateStudents());
        };
    }, []);

    if (message === "Registro eliminado correctamente") {
        dispatch(getStudentsThunk());
    }

    const handledeleteUser = (id) => {
        dispatch(deleteStudentThunk(id));
    };

    const filteredProducts = useMemo(() => {
        if (searchTerm) {
            return items.rows?.filter(item =>
                item?.apellido.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }
        return items.rows;
    }, [searchTerm, items]);

    return (
        <HomeLayout>
            {isLoading ? (
                <MainLoader />
            ) : (
                <div className='mx-5 my-5 w-full'>
                    {error ? <Error state={error} /> : " "}
                    <div className='flex w-full items-center p-2 border mb-2 shadow-sm'>
                        <HeaderComplete
                            title={t("Estudiantes")}
                            searchTerm={searchTerm}
                            funtion={e => setSearchTerm(e.target.value)}
                        />
                        <div className='flex gap-2 items-center w-[50%] justify-end'>
                            <BtnAdd to={`/panel/students/studet_new`} />
                            <UploadFileModal
                                title={'Subir estudiantes en bloque'}
                                funtion={uploadStudentExcelData}
                                message={success}
                                error={error_message}
                                process={process}
                                resetState={resetState}
                                getItems={getStudentsThunk}
                            />
                        </div>
                    </div>
                    <div className="h-[90%] flex flex-col  rounded overflow-hidden">
                        <div className="overflow-y-auto flex-1 contenedor">
                            <table className="min-w-full table-zebra table-fixed border-collapse text-[13px] text-left">
                                <thead className="sticky top-0 z-20 bg-white">
                                    <tr className='text-left h-[50px] bg-p-orange/80 text-white'>
                                        <th></th>
                                        <th>{t("Apellidos / Nombres")}</th>
                                        <th>{t("Paralelo")}</th>
                                        <th>{t("Progreso matriculación")}</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredProducts?.map((user, index) =>
                                        <tr className='h-[50px]' key={user.ci_estudiante}>
                                            <td className='pl-5 p-2'><IconStatus active={user.active} /></td>
                                            <td>
                                                <div className='flex flex-col gap-0'>
                                                    <p className='flex items-center gap-2 text-p-sky text-[18px]'>
                                                        {user.apellido} {user.nombre}
                                                    </p>
                                                    <p className='flex items-center gap-2 text-gray-500'>
                                                        {user.course?.name + ', ' + user.level?.name}
                                                    </p>
                                                </div>
                                            </td>
                                            <td>{user.parallel?.name} </td>
                                            <td>
                                                <div className='flex items-center justify-start'>
                                                    <Link to={`/panel/students/${user.ci_estudiante}/progress`} className="flex items-center gap-2 bg-gradient-to-r from-cyan-500 to-blue-500 text-white px-4 py-1 rounded-md shadow-md hover:from-cyan-600 hover:to-blue-600 transition-all duration-300 ease-in-out">
                                                        <svg className="w-5 h-5 animate-pulse" fill="none" stroke="currentColor" stroke-width="2"
                                                            viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                                d="M12 8c.379 0 .725.214.895.553l3.5 7A1 1 0 0115.5 17h-7a1 1 0 01-.895-1.447l3.5-7A1 1 0 0112 8z"></path>
                                                        </svg>
                                                        Ver progreso
                                                    </Link>
                                                </div>
                                            </td>
                                            <td>
                                                <div className='flex gap-1 justify-end items-center p-2'>
                                                    <BtnTable action="edit" to={`/panel/students/${user.ci_estudiante}`} />
                                                    {['Administrador'].includes(user.role) &&
                                                        <BtnTable title={t("user_delete")} action="delete" onclick={() => handledeleteUser(user.ci_estudiante)} />
                                                    }
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                                <tfoot className="sticky bottom-0 z-10 bg-gray-100 text-gray-700">
                                    <tr>
                                        <td colSpan={6} className="text-right p-2">
                                            Total de registros:{" "}
                                            <span className="text-p-sky text-[18px]">{items.count}</span>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            )}
        </HomeLayout>
    );
};

export default StudentList;
